import type { CommonReportResponse, ReportChapter, ReportSection } from "../api/types";
import { ReportChart } from "./sections/ReportChart";
import { ReportTable } from "./sections/ReportTable";
import { TextSection } from "./sections/TextSection";

function assertNever(value: never): never { throw new Error(`Unsupported report section: ${JSON.stringify(value)}`); }
function Section({ section }: { section: ReportSection }) {
  switch (section.sectionType) {
    case "text": return <TextSection section={section} />;
    case "table1": case "table2": case "zdytable": return <ReportTable section={section} />;
    case "chart": return <div id={String(section.sectionId)}>{section.sectionTitle && section.sectionTitle !== section.fxChart.strTitle ? <h3>{section.sectionTitle}</h3> : null}<ReportChart chart={section.fxChart} conclusion={section.conclusion} /></div>;
    default: return assertNever(section);
  }
}
function Chapter({ chapter }: { chapter: ReportChapter }) {
  return <section className={`fa-report-chapter is-level-${chapter.levelId}`} id={String(chapter.chapterId)} data-report-anchor={String(chapter.chapterId)}><h2>{chapter.chapterTitle}</h2>{(chapter.sections ?? []).map((section, index) => <Section section={section} key={`${section.sectionId}-${index}`} />)}{(chapter.chapters ?? []).map((child) => <Chapter chapter={child} key={String(child.chapterId)} />)}</section>;
}
export function CommonReportRenderer({ response }: { response: CommonReportResponse }) {
  return <>{response.result.chapters.map((chapter) => <Chapter chapter={chapter} key={String(chapter.chapterId)} />)}</>;
}
